import { apiRoutes } from 'config/apiRoutes'
import { useMutation, useQueryClient } from 'libs/query'
import { useTranslation } from 'libs/i18n'
import { useAxiosPrivate, useToast } from 'shared/hooks'
import { queryKeys } from 'config/queryKeys'

type UseDeleteProductMutationProps = {
	onSettled: () => void
}

export const useDeleteProductMutation = ({ onSettled }: UseDeleteProductMutationProps) => {
	const { t } = useTranslation()
	const axiosPrivate = useAxiosPrivate()
	const queryClient = useQueryClient()

	const { mutate: productDeleteMutation } = useMutation({
		mutationFn: (id: number | null) => {
			return axiosPrivate.delete(apiRoutes.productDelete(id))
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: queryKeys.products.all })
			useToast({
				type: 'success',
				message: t('Product deleted')
			})()
		},
		onError: () => {
			useToast({
				type: 'error',
				message: t('Something went wrong')
			})()
		},
		onSettled: () => {
			onSettled()
		}
	})

	return {
		productDeleteMutation
	}
}
